import React, { useState } from "react";
import Input from "../form/Input";
import { AiOutlineMail } from "react-icons/ai";
import { validateEmail } from "../../utils/Utils";
import Link from "next/link";
const BlogEmailCapture = ({ user }) => {
  const [formError, setFormError] = useState();
  const [email, setEmail] = useState();
  const [formSuccess, setFormSuccess] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const onSubmitClick = async (e) => {
    setFormError();
    e.preventDefault();

    if (!email || email == "") {
      setFormError("Please enter an email");
      return;
    }
    if (!validateEmail(email)) {
      setFormError("Email is not valid");
      return;
    }
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/klaviyo/blog/${email}/save`)
      .then((res) => {
        if (res.status === 200) {
          setButtonDisabled(true);
          setFormSuccess("Request has been sent successfully!");
          setFormError("");
        } else {
          setFormError("An error occurred. Please try again");
        }
      })
      .catch((err) => {
        console.error("err", err);
        setFormError("An error occurred. Please try again");
      });
  };

  return (
    <div className="row mt-5 pt-2 mb-4">
      {!user && (
        <form action="#">
          <div className="row ml-1">
            <div className="col-md-8">
              <Input
                style={{ borderRadius: "10px", width: "100%" }}
                icon={<AiOutlineMail />}
                type="email"
                placeholder="Enter your email to get access"
                onChange={handleEmailChange}
                value={email}
              />
            </div>
            <div className="col-md-4">
              <button
                style={{ margin: "0px", padding: "9px 20px" }}
                className="btn btn-lg btn-primary btn-gradient"
                onClick={onSubmitClick}
                disabled={buttonDisabled}
              >
                Get Free Picks
              </button>
            </div>
            <div className="col-12">
              {formError && <p className="text-danger">{formError}</p>}
              {formSuccess && <p className="text-success">{formSuccess}</p>}
            </div>
          </div>
        </form>
      )}

      {/* {user?.has_paid ? null : (
        <div className="col-12">
          <Link className="text-black is-link mt-4 mb-4 d-block" href={"/welcome-content-monthly"}>
            ⭐ Unlock Premium Content and early access to the Pick of the Day for Only <strong>$9.99/month</strong>
          </Link>
        </div>
      )} */}
    </div>
  );
};

export default BlogEmailCapture;
